import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Home from '../components/pages/Home/Home'
import Aboutpage from '../components/pages/Aboutpage/Aboutpage'
import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'
import Contact from '../components/pages/Contact/Contact'
import Product from '../components/pages/Product/Product'
import Clients from '../components/pages/Clients/Clients'
import WebApplicationDevelopment from '../components/pages/WebApplicationDevelopment/WebApplicationDevelopment'
import SliderAbout from '../components/pages/SliderAbout/SliderAbout'
import SliderAbout2 from '../components/pages/SliderAbout2/SliderAbout2'
import SliderAbout3 from '../components/pages/SliderAbout3/SliderAbout3'
import SliderAbout4 from '../components/pages/SliderAbout4/SliderAbout4'
import Project from '../components/pages/Projects/Project'
import TicketSolution from '../components/pages/Product/TicketSolution/TicketSolution'
import WorkforceManagement from '../components/pages/Product/WorkforceManagement/WorkforceManagement'
import DietCare from '../components/pages/Product/DietCare/DietCare'
import Service from '../components/pages/Service/Service'
import MobileApplicationDevelopment from '../components/pages/MobileApplicationDevelopment/MobileApplicationDevelopment'
import CustomSoftwareDevelopment from '../components/pages/CustomSoftwareDevelopment/CustomSoftwareDevelopment'
import ECommerceDevelopment from '../components/pages/ECommerceDevelopment/ECommerceDevelopment'
import SaasDevelopment from '../components/pages/SaasDevelopment/SaasDevelopment'
import Blogdetails1 from '../components/pages/BlogDetails/BlogDetails1/BlogDetails1'
import BlogDetails2 from '../components/pages/BlogDetails/BlogDetails2/BlogDetails2'
import ScrollSmootherProvider from '../components/ScrollSmoother/ScrollSmootherProvider'


function LayoutRoutes() {
  return (
    <Router>
      <Header />
        <ScrollSmootherProvider>
            
            <Routes>
                <Route path='/' element={<Home/>} />
                <Route path='/about' element={<Aboutpage/>} />
                <Route path='/Service' element={<Service />} />
                <Route path='/web-application-development' element={<WebApplicationDevelopment/>} />
                <Route path='/mobile-application-development' element={<MobileApplicationDevelopment/>} />
                <Route path='/custom-software-development' element={<CustomSoftwareDevelopment/>} />
                <Route path='/e-commerce-development' element={<ECommerceDevelopment/>} />
                <Route path='/saas-development' element={<SaasDevelopment/>} />
                <Route path='/product' element={<Product />} />
                <Route path='/project' element={<Project />} />
                <Route path='/clients' element={<Clients />} />
                <Route path='/contact' element={<Contact/>} />
                <Route path='/your-first-step-towards-transformation' element={<SliderAbout/>} /> 
                <Route path='/Perfecting-highly-streamlined-and-agile-development-process' element={<SliderAbout2/>} /> 
                <Route path='/tailoring-your-needs-with-the-sharpest-tools' element={<SliderAbout3/>} />
                <Route path='/leadin-you-through-a-journey-of-digital-excellence' element={<SliderAbout4/>} /> 
                <Route path='/ticketing-solution' element={<TicketSolution />} /> 
                <Route path='/workforce-management' element={<WorkforceManagement />} /> 
                <Route path='/diet-care' element={<DietCare />} />
                <Route path='/custom-web-design-solutions-in-qatar-tailored-for-success' element={<Blogdetails1 />} />
                <Route path='/how-cloud-computing-is-transforming-businesses-in-qatar' element={<BlogDetails2 />} />
            </Routes>
            <Footer />
        </ScrollSmootherProvider>
    </Router>
  )
}

export default LayoutRoutes
